import React, {
  useCallback, useEffect, useRef, useState,
} from 'react'

import { useShoppingCartContext } from '../../providers/ShoppingCartProvider'
import useIsDifmEnabled from '../../../DIFM/store/hooks/useIsDifmEnabled'
import { useNrAttributeContext } from '../../../../contexts/nrAttribute.context'

import useIsWmoEnabled from '../../../../hooks/useWmoEnabled'
import useMembershipEnabled from '../../../../hooks/useMembershipEnabled'
import { useMembershipStorage } from '../../../../hooks/useMembershipStorage'
import WrapperWmo from './WrapperWmo'
import { GTM } from '../../../../helpers'

const Wrapper = props => {
  const {
    tooltip,
  } = props

  const {
    showLoader,
    cartData,
    isCartDataMerged,
    setIsCartDataMerged,
    setItemsExceededStock,
    vendorItemsAddFailed,
    setVendorItemsAddFailed,
  } = useShoppingCartContext()
  const isDifmEnabled = useIsDifmEnabled()
  const { setDifmAttr } = useNrAttributeContext()
  const { items } = cartData
  const [isViewCart, setViewCart] = useState(false)
  const refresh = useCallback(
    () => {
      window.location.reload()
    },
    [],
  )

  if (__BROWSER__ && !isDifmEnabled) {
    const partNames = items ? items.map(item => item.part).join(',') : null
    setDifmAttr(0, partNames)
  }

  useEffect(
    () => () => {
      setIsCartDataMerged(false)
      setItemsExceededStock([])
      setVendorItemsAddFailed(false)
    },
    [setIsCartDataMerged, setItemsExceededStock, setVendorItemsAddFailed],
  )
  const isWmoEnabled = useIsWmoEnabled()

  useEffect(() => {
    if (isWmoEnabled && cartData?.items && !isViewCart) {
      GTM.viewCart(cartData)
      setViewCart(true)
    }
  }, [items])

  const isMembershipEnabled = useMembershipEnabled()
  const { membershipStorage } = useMembershipStorage()
  const membershipItems = (items || []).filter(i => i.inventory?.membershipShippingType === 'Free')
  const trackedMembershipItems = useRef([])
  const notYetTrackedMembershipItems = membershipItems.filter(
    membershipItem => !trackedMembershipItems.current.some(
      trackedItem => trackedItem.product.sku === membershipItem.product.sku,
    ),
  )

  useEffect(() => {
    if ((isMembershipEnabled || membershipStorage?.membership_status === 'ACTIVE') && notYetTrackedMembershipItems.length > 0) {
      notYetTrackedMembershipItems.forEach(item => {
        GTM.membershipCartSkuImpression(item.product.sku, item.product.part.name)
        trackedMembershipItems.current.push(item)
      })
    }
  }, [isMembershipEnabled, membershipStorage, notYetTrackedMembershipItems])

  return (
    <WrapperWmo
      refresh={refresh}
      items={items}
      showLoader={showLoader}
      cartData={cartData}
      isCartDataMerged={isCartDataMerged}
      vendorItemsAddFailed={vendorItemsAddFailed}
      tooltip={tooltip}
    />
  )
}

export default Wrapper
